import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Translation files
const resources = {
  en: {
    translation: {
      // Navigation
      "nav.dashboard": "Dashboard",
      "nav.fields": "Fields",
      "nav.subscription": "Subscription",
      "nav.logout": "Logout",
      
      // Dashboard
      "dashboard.title": "Dashboard",
      "dashboard.weather": "Weather",
      "dashboard.temperature": "Temperature",
      "dashboard.humidity": "Humidity",
      "dashboard.wind": "Wind Speed",
      "dashboard.precipitation": "Precipitation",
      "dashboard.activeFields": "Active Fields",
      "dashboard.noFields": "No fields added yet. Create your first field to start monitoring.",
      "dashboard.addField": "Add Field",
      "dashboard.forecast": "Weather Forecast",
      "dashboard.forecast48h": "48H",
      
      // Fields
      "fields.title": "Fields",
      "fields.addField": "Add Field",
      "fields.noFields": "No Fields Yet",
      "fields.createFirst": "Create your first field to start monitoring crops and weather.",
      "fields.crop": "Crop",
      "fields.gdd": "GDD",
      "fields.rain": "Rain",
      "fields.sowingDate": "Sowing Date",
      
      // Field Details
      "field.vegetation": "Vegetation",
      "field.harvest": "Harvest Field",
      "field.activities": "Field Activities",
      "field.addActivity": "Add Activity",
      "field.cropHealthScout": "Crop Health Scout",
      "field.alerts": "Active Alerts",
      
      // Subscription
      "subscription.title": "Subscription Plans",
      "subscription.freeTrial": "Free Trial",
      "subscription.monthly": "Premium Monthly",
      "subscription.yearly": "Premium Yearly",
      "subscription.subscribe": "Subscribe",
      "subscription.bestValue": "Best Value - Save 17%",
      
      // Common
      "common.loading": "Loading...",
      "common.save": "Save",
      "common.cancel": "Cancel",
      "common.close": "Close",
      "common.delete": "Delete",
      "common.edit": "Edit",
      "common.language": "Language",
    }
  },
  fr: {
    translation: {
      // Navigation
      "nav.dashboard": "Tableau de bord",
      "nav.fields": "Champs",
      "nav.subscription": "Abonnement",
      "nav.logout": "Déconnexion",
      
      // Dashboard
      "dashboard.title": "Tableau de bord",
      "dashboard.weather": "Météo",
      "dashboard.temperature": "Température",
      "dashboard.humidity": "Humidité",
      "dashboard.wind": "Vitesse du vent",
      "dashboard.precipitation": "Précipitations",
      "dashboard.activeFields": "Champs actifs",
      "dashboard.noFields": "Aucun champ ajouté. Créez votre premier champ pour commencer la surveillance.",
      "dashboard.addField": "Ajouter un champ",
      "dashboard.forecast": "Prévisions météorologiques",
      "dashboard.forecast48h": "48H",
      
      // Fields
      "fields.title": "Champs",
      "fields.addField": "Ajouter un champ",
      "fields.noFields": "Aucun champ",
      "fields.createFirst": "Créez votre premier champ pour surveiller les cultures et la météo.",
      "fields.crop": "Culture",
      "fields.gdd": "DJC",
      "fields.rain": "Pluie",
      "fields.sowingDate": "Date de semis",
      
      // Field Details
      "field.vegetation": "Végétation",
      "field.harvest": "Récolter le champ",
      "field.activities": "Activités du champ",
      "field.addActivity": "Ajouter une activité",
      "field.cropHealthScout": "Scout santé des cultures",
      "field.alerts": "Alertes actives",
      
      // Subscription
      "subscription.title": "Plans d'abonnement",
      "subscription.freeTrial": "Essai gratuit",
      "subscription.monthly": "Premium mensuel",
      "subscription.yearly": "Premium annuel",
      "subscription.subscribe": "S'abonner",
      "subscription.bestValue": "Meilleure valeur - Économisez 17%",
      
      // Common
      "common.loading": "Chargement...",
      "common.save": "Enregistrer",
      "common.cancel": "Annuler",
      "common.close": "Fermer",
      "common.delete": "Supprimer",
      "common.edit": "Modifier",
      "common.language": "Langue",
    }
  },
  it: {
    translation: {
      // Navigation
      "nav.dashboard": "Cruscotto",
      "nav.fields": "Campi",
      "nav.subscription": "Abbonamento",
      "nav.logout": "Esci",
      
      // Dashboard
      "dashboard.title": "Cruscotto",
      "dashboard.weather": "Meteo",
      "dashboard.temperature": "Temperatura",
      "dashboard.humidity": "Umidità",
      "dashboard.wind": "Velocità del vento",
      "dashboard.precipitation": "Precipitazioni",
      "dashboard.activeFields": "Campi attivi",
      "dashboard.noFields": "Nessun campo aggiunto. Crea il tuo primo campo per iniziare il monitoraggio.",
      "dashboard.addField": "Aggiungi campo",
      "dashboard.forecast": "Previsioni meteo",
      "dashboard.forecast48h": "48H",
      
      // Fields
      "fields.title": "Campi",
      "fields.addField": "Aggiungi campo",
      "fields.noFields": "Nessun campo",
      "fields.createFirst": "Crea il tuo primo campo per monitorare colture e meteo.",
      "fields.crop": "Coltura",
      "fields.gdd": "GDD",
      "fields.rain": "Pioggia",
      "fields.sowingDate": "Data di semina",
      
      // Field Details
      "field.vegetation": "Vegetazione",
      "field.harvest": "Raccogli campo",
      "field.activities": "Attività del campo",
      "field.addActivity": "Aggiungi attività",
      "field.cropHealthScout": "Scout salute colture",
      "field.alerts": "Avvisi attivi",
      
      // Subscription
      "subscription.title": "Piani di abbonamento",
      "subscription.freeTrial": "Prova gratuita",
      "subscription.monthly": "Premium mensile",
      "subscription.yearly": "Premium annuale",
      "subscription.subscribe": "Iscriviti",
      "subscription.bestValue": "Miglior valore - Risparmia 17%",
      
      // Common
      "common.loading": "Caricamento...",
      "common.save": "Salva",
      "common.cancel": "Annulla",
      "common.close": "Chiudi",
      "common.delete": "Elimina",
      "common.edit": "Modifica",
      "common.language": "Lingua",
    }
  },
  es: {
    translation: {
      // Navigation
      "nav.dashboard": "Panel",
      "nav.fields": "Campos",
      "nav.subscription": "Suscripción",
      "nav.logout": "Cerrar sesión",
      
      // Dashboard
      "dashboard.title": "Panel",
      "dashboard.weather": "Clima",
      "dashboard.temperature": "Temperatura",
      "dashboard.humidity": "Humedad",
      "dashboard.wind": "Velocidad del viento",
      "dashboard.precipitation": "Precipitación",
      "dashboard.activeFields": "Campos activos",
      "dashboard.noFields": "No hay campos agregados. Crea tu primer campo para comenzar el monitoreo.",
      "dashboard.addField": "Agregar campo",
      "dashboard.forecast": "Pronóstico del tiempo",
      "dashboard.forecast48h": "48H",
      
      // Fields
      "fields.title": "Campos",
      "fields.addField": "Agregar campo",
      "fields.noFields": "Sin campos",
      "fields.createFirst": "Crea tu primer campo para monitorear cultivos y clima.",
      "fields.crop": "Cultivo",
      "fields.gdd": "GDD",
      "fields.rain": "Lluvia",
      "fields.sowingDate": "Fecha de siembra",
      
      // Field Details
      "field.vegetation": "Vegetación",
      "field.harvest": "Cosechar campo",
      "field.activities": "Actividades del campo",
      "field.addActivity": "Agregar actividad",
      "field.cropHealthScout": "Scout salud de cultivos",
      "field.alerts": "Alertas activas",
      
      // Subscription
      "subscription.title": "Planes de suscripción",
      "subscription.freeTrial": "Prueba gratuita",
      "subscription.monthly": "Premium mensual",
      "subscription.yearly": "Premium anual",
      "subscription.subscribe": "Suscribirse",
      "subscription.bestValue": "Mejor valor - Ahorra 17%",
      
      // Common
      "common.loading": "Cargando...",
      "common.save": "Guardar",
      "common.cancel": "Cancelar",
      "common.close": "Cerrar",
      "common.delete": "Eliminar",
      "common.edit": "Editar",
      "common.language": "Idioma",
    }
  },
  de: {
    translation: {
      // Navigation
      "nav.dashboard": "Dashboard",
      "nav.fields": "Felder",
      "nav.subscription": "Abonnement",
      "nav.logout": "Abmelden",
      
      // Dashboard
      "dashboard.title": "Dashboard",
      "dashboard.weather": "Wetter",
      "dashboard.temperature": "Temperatur",
      "dashboard.humidity": "Luftfeuchtigkeit",
      "dashboard.wind": "Windgeschwindigkeit",
      "dashboard.precipitation": "Niederschlag",
      "dashboard.activeFields": "Aktive Felder",
      "dashboard.noFields": "Keine Felder hinzugefügt. Erstellen Sie Ihr erstes Feld, um mit der Überwachung zu beginnen.",
      "dashboard.addField": "Feld hinzufügen",
      "dashboard.forecast": "Wettervorhersage",
      "dashboard.forecast48h": "48H",
      
      // Fields
      "fields.title": "Felder",
      "fields.addField": "Feld hinzufügen",
      "fields.noFields": "Keine Felder",
      "fields.createFirst": "Erstellen Sie Ihr erstes Feld, um Pflanzen und Wetter zu überwachen.",
      "fields.crop": "Kultur",
      "fields.gdd": "GDD",
      "fields.rain": "Regen",
      "fields.sowingDate": "Aussaatdatum",
      
      // Field Details
      "field.vegetation": "Vegetation",
      "field.harvest": "Feld ernten",
      "field.activities": "Feldaktivitäten",
      "field.addActivity": "Aktivität hinzufügen",
      "field.cropHealthScout": "Pflanzengesundheit Scout",
      "field.alerts": "Aktive Warnungen",
      
      // Subscription
      "subscription.title": "Abonnementpläne",
      "subscription.freeTrial": "Kostenlose Testversion",
      "subscription.monthly": "Premium monatlich",
      "subscription.yearly": "Premium jährlich",
      "subscription.subscribe": "Abonnieren",
      "subscription.bestValue": "Bester Wert - Sparen Sie 17%",
      
      // Common
      "common.loading": "Wird geladen...",
      "common.save": "Speichern",
      "common.cancel": "Abbrechen",
      "common.close": "Schließen",
      "common.delete": "Löschen",
      "common.edit": "Bearbeiten",
      "common.language": "Sprache",
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    }
  });

export default i18n;
